import { B2BRegistrationFormData } from '../api/B2BRegistration.types';
import { FORM_STORAGE_KEY } from './constants';

const DEBOUNCE_MS = 500;
const TTL_MS = 24 * 60 * 60 * 1000;

interface StoredFormData {
  data: Partial<B2BRegistrationFormData>;
  timestamp: number;
}

let debounceTimer: ReturnType<typeof setTimeout> | null = null;

export const saveFormDataToLocalStorage = (data: Partial<B2BRegistrationFormData>): void => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  debounceTimer = setTimeout(() => {
    try {
      const storedData: StoredFormData = {
        data,
        timestamp: Date.now(),
      };
      localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(storedData));
    } catch (e) {
      // pass
    }
  }, DEBOUNCE_MS);
};

export const loadFormDataFromLocalStorage = (): Partial<B2BRegistrationFormData> | null => {
  try {
    const stored = localStorage.getItem(FORM_STORAGE_KEY);
    if (!stored) {
      return null;
    }

    const parsed: StoredFormData = JSON.parse(stored);

    if (Date.now() - parsed.timestamp > TTL_MS) {
      localStorage.removeItem(FORM_STORAGE_KEY);
      return null;
    }

    return parsed.data;
  } catch (e) {
    return null;
  }
};

export const clearLocalStorageCache = (): void => {
  try {
    localStorage.removeItem(FORM_STORAGE_KEY);
  } catch (e) {
    // pass
  }
};

export const hasCachedFormData = (): boolean => {
  try {
    return localStorage.getItem(FORM_STORAGE_KEY) !== null;
  } catch (e) {
    return false;
  }
};
